<ion-item>
  <ion-icon name="person" slot="start" size="large"></ion-icon>
  <ion-label class="ion-text-wrap">
    <ng-container *ngIf="patient.PatientNumber">
      <h2><strong translate>Mobile.PatientNumber</strong></h2>
      <h2>{{ patient.PatientNumber }}</h2>
    </ng-container>
    <div *ngIf="patient.Phone" (click)="call(patient.Phone)">
      <h2><strong translate>Mobile.PatientPhoneNumber</strong></h2>
      <h2>{{ patient.Phone }}</h2>
    </div>
    <ng-container *ngIf="patient.name">
      <h2><strong translate>Mobile.PatientFullName</strong></h2>
      <h2>{{ patient.name }}</h2>
    </ng-container>
    <ng-container *ngIf="patient.Gender">
      <h2><strong translate>Mobile.PatientGender</strong></h2>
      <h2>{{ patient.Gender }}</h2>
    </ng-container>
    <ng-container *ngIf="patient.Birthday">
      <h2><strong translate>Mobile.PatientDateOfBirth</strong></h2>
      <h2>{{ patient.Birthday | sagaDate: 'ShortDateFormat' }}</h2>
    </ng-container>
    <ng-container *ngIf="patient.location">
      <app-callcard-location-with-tools title="Mobile.PatientLocation" [location]="patient.location"></app-callcard-location-with-tools>
    </ng-container>
    <ng-container *ngIf="patient.location?.Complement">
      <h2><strong translate>Mobile.PatientLocationComplement</strong></h2>
      <h2>{{ patient.location.Complement }}</h2>
    </ng-container>
    <ng-container *ngIf="patient.NACA">
      <h2><strong translate>Mobile.PatientNaca</strong></h2>
      <h2>{{ patient.NACA }}</h2>
    </ng-container>
    <ng-container *ngIf="patient.SSP">
      <h2><strong translate>Mobile.PatientSsp</strong></h2>
      <h2>{{ patient.SSP }}</h2>
    </ng-container>
    <ng-container *ngIf="patient.TransportName">
      <h2><strong translate>Mobile.PatientTransport</strong></h2>
      <h2>{{ patient.TransportName }}</h2>
    </ng-container>
    <ng-container *ngIf="patient.MedicalizationName">
      <h2><strong translate>Mobile.PatientMedicalization</strong></h2>
      <h2>{{ patient.MedicalizationName }}</h2>
    </ng-container>
    <ng-container *ngIf="patient.destinationLocation">
      <app-callcard-location-with-tools
        title="Mobile.PatientDestinationLocation"
        [location]="patient.destinationLocation"
      ></app-callcard-location-with-tools>
    </ng-container>
    <ng-container *ngIf="patient.destinationLocation?.Complement">
      <h2><strong translate>Mobile.PatientDestinationLocationComplement</strong></h2>
      <h2>{{ patient.destinationLocation.Complement }}</h2>
    </ng-container>
  </ion-label>
</ion-item>
